import { acceptGoTuTermsApi } from './acceptGoTuTermsApi';
import {
  IAcceptGoTuTermsPayload,
  IAcceptGoTuTermsResponse,
} from './acceptGoTuTermsTypes';

const acceptGoTuTerms = async (
  payload: IAcceptGoTuTermsPayload
): Promise<IAcceptGoTuTermsResponse> => {
  const response = await acceptGoTuTermsApi.acceptGoTuTerms(payload);

  return response;
};

export const acceptGoTuTermsService = {
  acceptGoTuTerms,
};
